import { Helmet } from "react-helmet";
import hero from "../images/kamaainaHero.jpg";
import leftWaikiki from "../images/kamaainaWaikiki.jpg";
import leftMaui from "../images/leftMaui.jpg";
import leftKona from "../images/2 Kona.jpg";
import leftMajestic from "../images/kamaainaSunset.jpg";
import leftFireworks from "../images/kamaainaFireworks.jpg";
import LeftRight from "../components/LeftRight";
import leftWhale from "../images/leftWhale.jpg";

function Kamaaina() {
  return (
    <>
      <Helmet>
        <title>
          Atlantis Submarine Adventures | Kama'aina Ticket Discounts
        </title>
      </Helmet>
      <div className="container mw-100">
        <div className="row position-relative heightVideo">
          <img src={hero} className="p-0 homeVidSizeNew" alt="hero" />
          <div className="homeTextOverlayVideo fw-semibold lh-sm">
            KAMA'AINA TICKET DISCOUNTS
          </div>
        </div>
        <LeftRight
          left={leftWaikiki}
          title="ATLANTIS SUBMARINES WAIKIKI"
          p1="Explore a side of Waikiki over 100 feet beneath the sea that you and your Ohana may have never seen before in an air-conditioned submarine. Add deeper meaning to your next adventure by discovering marine life, sunken ships and other fascinating artificial reefs in the world’s largest battery-powered, Coast Guard-approved sub."
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Hawaii ID or Military ID is required at check-in*
            </>
          }
          link="https://book.atlantisadventures.com/details/205302/atlantis-premium-submarine-tour-waikiki-kamaaina-discount"
          button
          kamaaina
          // adult="111"
          adult="99"
          child="49.50"
          // saveAdult="37"
          saveAdult="49"
          saveChild="16.50"
          thingsReal
        />
        <LeftRight
          left={leftMaui}
          title="ATLANTIS SUBMARINES MAUI"
          p1="Marvel at Maui’s unique underwater paradise aboard the most technologically advanced 48-passenger, battery-powered submarine. Kama’aina will see unique and fascinating natural coral reefs, fish, and marine life in air-conditioned comfort and safety. A highlight of this submarine adventure is also the chance to see a famous sunken ship called the Carthaginian, which serves as an artificial reef to help enhance Maui’s marine environment."
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Hawaii ID or Military ID is required at check-in*
            </>
          }
          changeBG
          link="https://book.atlantisadventures.com/details/205329/atlantis-submarine-tour-maui-kamaaina-discount"
          button
          kamaaina
          // adult="111"
          adult="99"
          child="49.50"
          // saveAdult="37"
          saveAdult="49"
          saveChild="16.50"
          thingsReal
        />
        <LeftRight
          left={leftKona}
          title="ATLANTIS SUBMARINES KONA"
          p1="Discover Kona’s world beneath the waves aboard our battery-powered, eco-friendly submarine which is part of our fleet of the world’s most technologically advanced passenger submarines. Explore Kona’s exciting marine life and a pristine 25-acre coral reef, along with sunken ships in air-conditioned comfort and safety."
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Hawaii ID or Military ID is required at check-in*
            </>
          }
          link="https://book.atlantisadventures.com/details/205340/atlantis-submarine-tour-kona-kamaaina-discount"
          button
          kamaaina
          // adult="111"
          adult="99"
          child="49.50"
          // saveAdult="37"
          saveAdult="49"
          saveChild="16.50"
          thingsReal
        />
        <LeftRight
          left={leftMajestic}
          title="MAJESTIC WAIKIKI SUNSET COCKTAIL CRUISE"
          p1="Step out onto Majestic’s open-air decks and enjoy Hawaii’s beautiful sunsets and skylines. Majestic features two decks that offer the space to take in panoramic views and lovely breezes."
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Hawaii ID or Military ID is required at check-in*
            </>
          }
          link="https://book.majestichawaii.com/details/309586/waikiki-sunset-cocktail-cruise-kamaaina-discount"
          changeBG
          button
          kamaaina
          adult="32.00"
          child="29.63"
          saveAdult="47.00"
          saveChild="9.87"
          free
          thingsReal
        />
        <LeftRight
          left={leftWhale}
          title="MAJESTIC WHALE WATCH CRUISE (Whale Watch will return in December 2025!)"
          p1="Each year, humpback whales return to the islands from frigid Alaska to breed, calve, and nurse their young. Come witness this amazing event for yourself on board the Majestic!"
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Hawaii ID or Military ID is required at check-in*
            </>
          }
          link="https://book.majestichawaii.com/details/221534/whale-watch-cruise-in-waikiki-kamaaina-discount"
          button
          kamaaina
          adult="32.00"
          child="29.63"
          saveAdult="47.00"
          saveChild="9.87"
          free
          thingsReal
        />
        <LeftRight
          left={leftFireworks}
          title="MAJESTIC FRIDAY FIREWORKS & COCKTAIL CRUISE"
          p1="Experience an unforgettable evening with Friday night fireworks and cocktails on the sea aboard Majestic by Atlantis Cruises."
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Hawaii ID or Military ID is required at check-in*
            </>
          }
          link="https://book.majestichawaii.com/details/317222/friday-fireworks-cocktail-cruise-kamaaina-discount"
          changeBG
          button
          kamaaina
          adult="32.00"
          child="29.63"
          saveAdult="47.00"
          saveChild="9.87"
          free
          thingsReal
        />
      </div>
    </>
  );
}

export default Kamaaina;
